module.exports = __webpack_public_path__ + "static/media/cards.10aa7898.svg";